declare var jQuery:any;
declare var $:any;

// Imports Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Compiler } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

// External Modules
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './configuracion/material.module';
import { SessionStorageService } from 'ngx-webstorage';
import { Ng2Webstorage } from 'ngx-webstorage';
import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { Logger } from 'angular2-logger/core';

/*translation */
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Components view
import { AppComponent } from './app.component';
import { PieComponent } from './components/pie/pie.component';
import { IngresoComponent } from './components/ingreso/ingreso.component';
import { DFirmaComponente } from '@dian-cmp/firma';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DSpeedDialComponente } from '@dian-cmp/speed-dial';
import { DatepickerModule } from '@dian-cmp/datepicker';
import { DPreguntasComponente } from '@dian-cmp/preguntas';
import { DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DReciboPagoModule } from '@dian-cmp/recibo-pago';

// Libs framework
import { DLogger } from '@dian/core';
import { DLoggerAngular } from '@dian/core';
import { DContextoMuiscaServicio } from '@dian/core';
import { DSessionStorage } from '@dian/core';
import { DContextoMuiscaDesaServicio } from '@dian/core';
import { DFormularioServicio } from '@dian/api-formulario';
import { 
  DOperacionesMatematicasServicio, 
  DValidacionesFormularioServicio,
  FormateoValorPipe,
  FormatoMonedaDirectiva,
  DMostrarAyudaBaseComponent
} from '@dian-cmp/formulario';

// Conf
import { loggerFactory, contextoMuiscaFactory, formularioFactory, sessionStorageFactory, validacionesFormularioFactory, HttpLoaderTranslatorFactory } from './configuracion/app.factories';
import { DFormularioConfiguracion } from './configuracion/dformulario-configuracion';
import { AppRoutingModule } from './app-routing.module';
import { MissingTranslationHandlerDIAN } from './configuracion/missing-translation-handler-dian';
import { DHoverDirective } from './directives/dhover.directive';



@NgModule({
  declarations: [
    AppComponent,
    PieComponent,
    IngresoComponent,
    DNotificacionesComponente,
    DSpeedDialComponente,
    DFirmaComponente,
    DEnvioLogComponente,
    DPreguntasComponente,
    FormateoValorPipe,
    FormatoMonedaDirectiva,
    DMostrarAyudaBaseComponent,
    DHoverDirective
  ],
  imports: [
    //Angular
    BrowserModule,
    HttpModule, 
    FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),
    //Traductor
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderTranslatorFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler, 
        useClass: MissingTranslationHandlerDIAN
      }
    }),
    //Material
    FlexLayoutModule,
    MaterialModule,
    DatepickerModule,
    DateValueAccessorModule,  
    DReciboPagoModule,  
    //Aplicacion
    AppRoutingModule 
  ],
  providers: [
    CookieService, 
    Compiler,
    Logger,
    DNotificacionServicio,
    {
        provide: DLogger,
        useFactory: loggerFactory,
        deps: [Logger, SessionStorageService]
    },
    {
        provide: DSessionStorage,
        useFactory: sessionStorageFactory,
        deps: [SessionStorageService,DLogger]
    },
    {
        provide: DContextoMuiscaServicio,
        useFactory: contextoMuiscaFactory,
        deps: [Http, CookieService, Compiler, DLogger, DNotificacionServicio, DSessionStorage, DFormularioConfiguracion]
    },  
    {
        provide:  DFormularioServicio,
        useFactory: formularioFactory,
        deps: [DContextoMuiscaServicio]            
    }, 
    {
        provide: DValidacionesFormularioServicio,
        useFactory: validacionesFormularioFactory,
        deps: [DFormularioConfiguracion, DOperacionesMatematicasServicio]
    },             
    FormateoValorPipe,
    DOperacionesMatematicasServicio,
    DFormularioConfiguracion    
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [
    DNotificacionesComponente, 
    DEnvioLogComponente,
    DFirmaComponente    
  ]
})
export class AppModule { 

  /**
  * @constructor
  */
  constructor(){
    this.abrirAyuda();
  }

  /**
  * @desc Funcion para iniciar la ayuda 
  */
  private abrirAyuda() {
    //trigger ayuda pie
    setTimeout(function(){
      var seg = 0;
      $('.ayuda').tapTarget('open');  
      setInterval(function(){
        seg++;
        if(seg === 5){
          $('.ayuda').tapTarget('close');
          cerrarAyudaBtn();           
        }
      }, 1000);
    }, 3000);
      
    //Funcion para cerrar la ayuda y eliminarla para prevenir que se vuelva a abrir
    function cerrarAyudaBtn(){
      $('.ayuda').tapTarget('close'); 
      $("#btn-ayuda").show(); 
    }
  }  

}



// WEBPACK FOOTER //
// D:/350/ng_ingreso_retefuente350/ReteFuente350Ingreso/src/app/app.module.ts